import { Grid } from '@material-ui/core';
import { ContaBancariaForm } from 'app/main/pessoa/ContaBancaria';
import React from 'react';

const TabContaBancariaCliente = ({ onChange, onBlur, values, errors, touched, submitCount }) => {
  // nos outros Form tá usando o context do formik, esse recebe "handleChange", e os value
  return (
    <Grid container spacing={3}>
      <ContaBancariaForm
        handleChange={onChange}
        required={false}
        onBlur={onBlur}
        errors={errors}
        touched={touched}
        contaBancaria={values?.pessoa?.conta?.contaBancaria}
        contaDescricao={values?.pessoa?.conta?.descricao}
      />
    </Grid>
  );
};

export default TabContaBancariaCliente;
